<img src="assets/images/cim_ci.png"
    [attr.width]="imgWidth"
    [attr.height]="imgHeight"
    alt="Logo">
